import { Component, OnInit } from '@angular/core';
import { DialogRef } from 'angular2-modal';

import { SharedHackService } from '../../services/shared-hack.service';
import { SharedClientCandidateService } from '../../../shared/services/shared-candidate.service';

import { default as swal } from 'sweetalert2';
import { AuthService } from '../../../../../providers/auth.service';


export class HackResultModalComponent implements OnInit {
	public hackResults: any = null;
	public hackReports: any = null;
	public candidate: any = null;
	public uiEventsReport: any = {};
	public credentials: any = {};

	constructor(
		public dialog: DialogRef<any>,
		private authService: AuthService,
		private sharedClientCandidateService: SharedClientCandidateService,
		private sharedHackService: SharedHackService) { }

	public ngOnInit(): void {
		if (this.checkInitData()) {
			this.credentials.clientId = String(this.authService.userId);

			this.getHackResults();
			this.getHackUiEvents();
			this.getHackReports();
			this.getCandidate();
		}
	}

	public closeModal(): void {
		this.dialog.close();
	}

	private getHackResults(): void {
		this.sharedHackService.getHackResults(this.credentials.clientId, this.credentials.candidateId, this.credentials.hackId).subscribe(
			(results) => {
				this.hackResults = results;
			},
			(error) => {
				if (error.status === 402) {
					swal({
						title: `No credits available`,
						text: `You cannot view hack results!`,
						type: 'error',
						showCancelButton: false,
						confirmButtonColor: '#008fb3',
						confirmButtonText: 'Ok',
						allowOutsideClick: false,
						allowEscapeKey: false
					}).then(() => {
						this.closeModal();
					});
				}
			}
		);
	}

	private getHackUiEvents(): void {
		this.sharedHackService.getHack(this.credentials.clientId, this.credentials.hackId).subscribe(
			(hack) => this.sharedHackService.getHackUiEvents(this.credentials.clientId, this.credentials.candidateUuid, hack.uuid).subscribe(
				(report) => {
					if (!report) {
						return;
					}

					const reportMap = {stats: report.stats};
					report.challenges_events.forEach((challenge) => {
						if (!reportMap[challenge.challenge_type]) {
							reportMap[challenge.challenge_type] = {};
						}

						reportMap[challenge.challenge_type][challenge.challenge_id] = {
							stats: challenge.stats,
							events: challenge.events
						};
					});
					this.uiEventsReport = reportMap;
				}
			)
		);
	}

	private getHackReports(): void {
		this.sharedHackService.getHackReports(this.credentials.clientId, this.credentials.candidateId, this.credentials.hackId).subscribe(
			(reports) => {
				this.hackReports = reports;
			}
		);
	}

	private getCandidate(): void {
		this.sharedClientCandidateService.getByUuid(this.credentials.clientId, this.credentials.candidateUuid, '', 'hack-result').subscribe(
			(candidate) => {
				this.candidate = candidate;
			}
		);
	}

	private checkInitData(): boolean {
		let pass: boolean = true;
		if (!this.dialog.context.initData) {
			pass = false;
		}
		if (!this.dialog.context.initData.candidateId || !this.dialog.context.initData.hackId) {
			pass = false;
		}
		if (!pass) {
			this.closeModal();
			this.handleError({message: 'The mandatory data is missing!'});
		} else {
			this.credentials = this.dialog.context.initData;
		}
		return pass;
	}

	private handleError(error: any) {
		let errMsg = (error.message) ? error.message :
			error.status ? `${error.status} - ${error.statusText}` : 'Server error';
		swal({
			title: `Oops, there's been an error`,
			text: `Our tech team has been notified, however please email contact@hackajob.co and we'll try and solve the issue as soon as possible. Thanks and sorry for any inconvenience.`,
			type: 'error',
			showCancelButton: false,
			confirmButtonColor: '#008fb3',
			confirmButtonText: 'Ok',
			allowOutsideClick: false,
			allowEscapeKey: false
		});
	}
static ctorParameters() { return [ { type: DialogRef }, { type: AuthService }, { type: SharedClientCandidateService }, { type: SharedHackService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/shared/modals/hack-result/hack-result-modal.component.ts